import React from 'react';
import { useNavigate } from 'react-router-dom';

function FloatingTalkButton() {
  const navigate = useNavigate();

  return (
    <button className="floating-talk-btn" onClick={() => navigate('/contact')} aria-label="Book a free consultation">
      Book a Consultation
    </button>
  );
}

export default FloatingTalkButton;
